import { getRequest, postRequest, severityCode } from "./httpClient";

const END_POINT = "token";

const getProjectToken = async () => {
  return await getRequest(`project/token`);
};

const getSubLocationToken = async (paoId) => {
  const response = await getRequest(`${END_POINT}/partyaddress/${paoId}/sublocations`);
  return response;
};

const getBuildingsFilterToken = async (token, filterData) => {
  console.log("token.api getBuildingsFilterToken: ", token, filterData);
  const response = await postRequest(`${END_POINT}/building/${token}/filter`, { filterData: filterData });
  return response.data;
};

const getSubLocationsFilterToken = async (token, filterData) => {
  const response = await postRequest(`${END_POINT}/sublocations/${token}/filter`, { filterData: filterData });
  return response.data;
};

const getAppliedFilterToken = async (token, filterData) => {
  const response = await postRequest(`${END_POINT}/applied/${token}/filter`, { filterData: filterData });
  return response.data;
};

const getAppliedLogFilterToken = async (token, filterData) => {
  const response = await postRequest(`${END_POINT}/applied/${token}/logs/filter`, { filterData: filterData });
  return response.data;
};

export { getProjectToken, getSubLocationToken, getBuildingsFilterToken, getSubLocationsFilterToken, getAppliedFilterToken, getAppliedLogFilterToken, severityCode };
